import type { CurrentUser } from '../../../types'

/**
 * Poslední známý profil přihlášeného uživatele.
 *
 * Bez něj by aplikace po obnovení stránky bez připojení vypadala jako
 * odhlášená - server se nedá zeptat, kdo je přihlášený. Session cookie zůstává
 * jediným skutečným dokladem přihlášení, tohle je jen podklad pro zobrazení.
 */
const KLIC = 'splitup:profil'

export function readCachedUser(): CurrentUser | undefined {
    try {
        const raw = localStorage.getItem(KLIC)
        return raw ? (JSON.parse(raw) as CurrentUser) : undefined
    } catch {
        return undefined
    }
}

export function writeCachedUser(user: CurrentUser): void {
    try {
        localStorage.setItem(KLIC, JSON.stringify(user))
    } catch {
        // Zakázané úložiště nesmí bránit přihlášení.
    }
}

export function clearCachedUser(): void {
    try {
        localStorage.removeItem(KLIC)
    } catch {
        // Nic k řešení.
    }
}
